import { useEffect, useState } from 'react';
import axios from 'axios';
import { isAndroidApp } from '../lib/platform';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/** Web-only probe: is the logged-in Student a recharge-card delegate? */
export function useDelegateAccess(role) {
  const [isDelegate, setIsDelegate] = useState(false);
  useEffect(() => {
    if (role !== 'Student' || isAndroidApp()) return undefined;
    let on = true;
    axios.get(`${API_URL}/api/recharge-cards/my-access`, { withCredentials: true })
      .then((r) => { if (on) setIsDelegate(!!r.data?.is_delegate || !!r.data?.has_cards); })
      .catch(() => {});
    return () => { on = false; };
  }, [role]);
  return isDelegate;
}
